export const TITLE_TABLE_DETAIL = [
  {
    label: 'library.selectedFilter.COMPANY',
    key: 'organizationName',
  },
  {
    label: 'library.detailsPortfolios.TAX_CODE',
    key: 'taxCode',
  },
  {
    label: 'library.detailsPortfolios.STATUS',
    key: 'status',
  },
  {
    label: 'library.detailsPortfolios.ALERT',
    key: 'alertStatusId',
  },
  {
    label: 'library.detailsPortfolios.DATE_DOWNLOADED',
    key: 'deliveryDate',
  },
  {
    label: ' ',
    key: 'col6',
  },
]

export const TITLE_TABLE_ADD_COMPANY = [
  {
    label: '#',
    key: 'stt',
  },
  {
    label: 'library.detailsPortfolios.TAX_CODE',
    key: 'taxCode',
  },
  {
    label: 'library.savePortfolio.COMPANY',
    key: 'companyName',
  },
  {
    label: '',
    key: '',
  },
]

export const TYPE_SORT_TABLE_DETAIL = {
  DELIVERY_DATE: 'deliveryDate',
  ACTIVE_STATUS_NAME: 'status',
  ALERT: 'alertStatusId',
}
export const MAP_SORT_TABLE_DETAIL = {
  [TYPE_SORT_TABLE_DETAIL.DELIVERY_DATE]: 'deliveryDate',
  [TYPE_SORT_TABLE_DETAIL.ACTIVE_STATUS_NAME]: 'status',
  [TYPE_SORT_TABLE_DETAIL.ALERT]: 'alert',
}

export const TYPE_POPUP_MOVE_COPY = {
  COPY: 'COPY',
  MOVE: 'MOVE',
}
